export default {
  "content": "<path stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M4 9.233L6.756 11.9 12 5.5\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "17",
    "fill": "none",
    "viewBox": "0 0 16 17"
  }
};